// extracted by mini-css-extract-plugin
export default {"snackbar-provider-container":"SnackbarProvider_snackbar-provider-container__pKDXa"};